const RAW = `
US|+1|Estados Unidos
CA|+1|Canadá
MX|+52|México
GT|+502|Guatemala
BZ|+501|Belice
SV|+503|El Salvador
HN|+504|Honduras
NI|+505|Nicaragua
CR|+506|Costa Rica
PA|+507|Panamá
CU|+53|Cuba
DO|+1|República Dominicana
HT|+509|Haití
JM|+1|Jamaica
PR|+1|Puerto Rico
CO|+57|Colombia
VE|+58|Venezuela
EC|+593|Ecuador
PE|+51|Perú
BO|+591|Bolivia
CL|+56|Chile
AR|+54|Argentina
UY|+598|Uruguay
PY|+595|Paraguay
BR|+55|Brasil
GY|+592|Guyana
SR|+597|Surinam
ES|+34|España
PT|+351|Portugal
FR|+33|Francia
DE|+49|Alemania
IT|+39|Italia
GB|+44|Reino Unido
IE|+353|Irlanda
NL|+31|Países Bajos
BE|+32|Bélgica
LU|+352|Luxemburgo
CH|+41|Suiza
AT|+43|Austria
SE|+46|Suecia
NO|+47|Noruega
DK|+45|Dinamarca
FI|+358|Finlandia
PL|+48|Polonia
CZ|+420|Chequia
SK|+421|Eslovaquia
HU|+36|Hungría
RO|+40|Rumanía
BG|+359|Bulgaria
GR|+30|Grecia
HR|+385|Croacia
RS|+381|Serbia
UA|+380|Ucrania
RU|+7|Rusia
TR|+90|Turquía
IL|+972|Israel
SA|+966|Arabia Saudita
AE|+971|Emiratos Árabes Unidos
QA|+974|Catar
KW|+965|Kuwait
EG|+20|Egipto
MA|+212|Marruecos
DZ|+213|Argelia
TN|+216|Túnez
ZA|+27|Sudáfrica
NG|+234|Nigeria
KE|+254|Kenia
GH|+233|Ghana
ET|+251|Etiopía
CN|+86|China
JP|+81|Japón
KR|+82|Corea del Sur
IN|+91|India
PK|+92|Pakistán
BD|+880|Bangladés
ID|+62|Indonesia
MY|+60|Malasia
SG|+65|Singapur
TH|+66|Tailandia
VN|+84|Vietnam
PH|+63|Filipinas
AU|+61|Australia
NZ|+64|Nueva Zelanda
`;

const flagEmoji = (iso) => iso.toUpperCase().replace(/./g, (char) => (
  String.fromCodePoint(127397 + char.charCodeAt(0))
));

export const PHONE_COUNTRY_PREFIXES = RAW.trim().split('\n').map((line) => {
  const [iso, dial, name] = line.split('|');
  return { iso, dial, name, flag: flagEmoji(iso) };
});

export const DEFAULT_PHONE_PREFIX = PHONE_COUNTRY_PREFIXES.find((item) => item.iso === 'EC');

const NATIONAL_LENGTH = {
  EC: [9, 9], US: [10, 10], CA: [10, 10], MX: [10, 10], CO: [10, 10],
  PE: [9, 9], CL: [9, 9], AR: [10, 10], BR: [10, 11], ES: [9, 9],
  GB: [10, 10], DE: [10, 11], FR: [9, 9], IT: [9, 10],
};

export const nationalLengthFor = (prefix) => {
  const known = NATIONAL_LENGTH[prefix?.iso];
  if (known) {
    return { min: known[0], max: known[1] };
  }
  const dialDigits = String(prefix?.dial || '').replace(/\D/g, '').length || 1;
  const max = Math.max(4, 15 - dialDigits);
  return { min: Math.min(6, max), max };
};

export const normalizeNationalNumber = (value, prefix) => {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.startsWith('0')) {
    digits = digits.slice(1);
  }
  return digits.slice(0, nationalLengthFor(prefix).max);
};
